import { memo } from 'react'
import styled from 'styled-components'
import { SystemIcon, RowSetPositionCategory } from 'components'

function TableSetPositionCategory({
  data,
  allProductData,
  handleChangeActive,
  handleClickDetail,
  handleClickUpdate,
  isAllowedForSelectCategory,
}) {
  return (
    <>
      <Container>
        <thead>
          <Tr>
            <Th ratio="4">
              SUB-KATEGORY
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th ratio="3">jumlah produk</Th>
            <Th ratio="2">AKSI</Th>
          </Tr>
        </thead>
        <tbody>
          {allProductData && (
            <RowSetPositionCategory
              data={allProductData}
              isAllowedForSelectCategory={isAllowedForSelectCategory}
            />
          )}
          {data?.map((items, index) => {
            return (
              <RowSetPositionCategory
                data={items}
                isAllowedForSelectCategory={isAllowedForSelectCategory}
                key={'dad' + index + 'set'}
              />
            )
          })}
        </tbody>
      </Container>
    </>
  )
}

export default memo(TableSetPositionCategory)

const Container = styled.table`
  width: 100%;
`
const Tr = styled.tr`
  display: flex;
  padding: 16px 32px;
  background-color: ${({ theme: { colors } }) => colors.tableHead};
`
const Th = styled.th`
  color: ${({ theme: { colors } }) => colors.grey};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  flex: ${({ ratio }) => ratio};
  text-align: start;
`
